import React, { useState } from 'react'
import "./auth.css"
// import Header from '../Header'
// import Footer from '../Footer'
import { MDBInput } from 'mdb-react-ui-kit';
import Url from '../../../url'

function Auth({updateLocalStorage}) {
    const [ fName, setfName ] = useState("")
    const [ lName, setlName ] = useState("")
    const [ email, setEmail ] = useState("")
    const [ password, setPassword ] = useState("")
    const [ login, setLogin ] = useState(true)

        
    const authState = () => {
        return login ? "Login" : "Sign Up"
    }

    const authButton = () =>{
        return !login ? "Login" : "Sign Up"
    }

    const authToggle = () =>{
        setLogin(!login)
        setfName("")
        setlName("")
        setEmail("")
        setPassword("")
    }

    const handleSubmit = e => {
        e.preventDefault()

        let url = login ?
        `${Url}login` :
        `${Url}signup`

        let requestBody = login ? {
            email: email,
            password: password
        } : {
            fName: fName,
            lName: lName,
            email: email,
            password: password
        }

        fetch(url, {
            method: "POST",
            body: JSON.stringify(requestBody),
            headers: new Headers({
                "Content-Type": "application/json"
            })
        })
        .then(res => res.json())
        .then(data => { 
            if (data.error) {
                setEmail("")
                setPassword("")
                alert(data.error)
            }
            else {
                let user = data.findUser
                let token = data.token
                let admin = user.isAdmin
                updateLocalStorage(token,user.email,admin)
            }
            })
        .catch(err => console.log(err))
    }

    const register = () => login ? null : (
        <>
        
        <MDBInput 
            type="text"  
            className="fName" 
            id='form1'
            value={fName}
            label='First Name'
            onChange={e => setfName(e.target.value)}/>
        <MDBInput type="text" 
            value={lName}
            label='Last Name'
            className='lName' 
            id='form1'
            onChange={e => setlName(e.target.value)}/>
        </>
    )

    return (
        <div className='authPage'>
            <div className='container-lg'>
                <h3 className='authState' >{authState()}</h3>
                <form 
                action="" 
                className="form-wrapper"
                >
                    {register()}
                    <MDBInput 
                        type="email" 
                        className="email" 
                        id='form1'
                        value = {email}
                        label='Enter Email'
                        autoComplete="new-password"
                        onChange={e => setEmail(e.target.value)} />
                    <MDBInput 
                        type="password" 
                        className="password" 
                        id='form1'
                        value = {password}
                        label='Enter Password' 
                        autoComplete="new-password"
                        onChange={e => setPassword(e.target.value)}/>
                <button className='btn btn-primary'
                    onClick={handleSubmit                        
                        }>{authState()}</button>
                </form>
                <button className='btn btn-primary' onClick={authToggle}>{authButton()}</button>
            </div>
        
        </div>
        
    )
}

export default Auth